export function BrandLogo() {
  return (
    <a href="/ui/" className="flex items-center gap-2 no-underline text-[var(--color-text)]">
      <img src="/ui/logo.svg" alt="" className="h-7 w-7" aria-hidden />
      <span className="font-display text-lg leading-none">to.dyakov.space</span>
    </a>
  );
}
